import {SearchIcon} from '../Search/SearchIcon';
import type {CSSObject} from '@mui/material';
import {styled} from '@mui/material/styles';
import React from 'react';
import {IconButton} from '../Button/IconButton';
import type {PopoverContentProps} from '../Popover';
import {Popover, PopoverButton, PopoverContent} from '../Popover';
import {Search} from '../Search';
import {useHeaderState} from './HeaderStateContext';
import {headerCssClassNames} from './headerCssClassNames';
import clsx from 'clsx';

const StyledPopoverContent = styled(PopoverContent)({
    width: '100%'
});

export const HeaderSearch = React.forwardRef<HTMLDivElement, unknown>((props, ref) => {
    const {
        HeaderSearchProps, HeaderSearchButtonProps,
        isLaptop, isDesktop, isWideScreen
    } = useHeaderState();

    const inputRef = React.useRef<HTMLInputElement>(null);

    const popperModifiers: PopoverContentProps['popperModifiers'] = [
        {
            name: 'offset',
            options: {
                offset: [0, 6]
            }
        }
    ];

    const showDesktopSearch = isLaptop || isDesktop || isWideScreen;

    return (
        showDesktopSearch ? (
            <Search
                {...HeaderSearchProps}
                className={headerCssClassNames.searchInput}
                inputRef={inputRef}
                ref={ref}
                sx={{
                    maxWidth: '14rem'
                }}
                variant='filled'
            />
        ) : (
            <Popover
                showClose={false}
            >
                <PopoverButton
                    aria-label='Search'
                    {...HeaderSearchButtonProps}
                    className={clsx(
                        headerCssClassNames.searchMobileButton,
                        'FuelSearchButtonMobile'
                    )}
                    component={IconButton}
                    sx={{
                        ml: 'auto'
                    }}
                >
                    <SearchIcon/>
                </PopoverButton>
                <StyledPopoverContent
                    PaperProps={{
                        className: headerCssClassNames.searchPopover,
                        sx: (theme): CSSObject => ({
                            boxShadow: 'none',
                            borderRadius: 0,
                            padding: theme.tokens.FuelSpacing4
                        })
                    }}
                    align='center'
                    popperModifiers={popperModifiers}
                >
                    <Search
                        {...HeaderSearchProps}
                        className={headerCssClassNames.searchInput}
                        inputRef={inputRef}
                        ref={ref}
                        variant='filled'
                    />
                </StyledPopoverContent>
            </Popover>
        )
    );
});

HeaderSearch.displayName = 'HeaderSearch';
